// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./header.css";
// import logo from "../logo.png";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
// import PermIdentityIcon from "@mui/icons-material/PermIdentity";
// import TuneIcon from "@mui/icons-material/Tune";
// import Grid from "@mui/material/Grid";
// import Badge from "@mui/material/Badge";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
// import { Toolbar, Typography, Box, CircularProgress, useTheme, useMediaQuery } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import { Drawer, IconButton, List, ListItem, ListItemText, Button, Menu, Divider, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Chip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import CloseIcon from "@mui/icons-material/Close";
// import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useNavigate } from "react-router-dom";
// import Avatar from '@mui/material/Avatar';
// import { fetchCart, fetchWishlist, addToWishlist, removeFromWishlist, fetchProfileImage, setProfileImage, clearCart, clearWishlist } from './store';
// import { useDispatch, useSelector } from 'react-redux';
// import BasicSelectFilter from "./filter";
// import { useSnackbar } from 'notistack';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import InputAdornment from '@mui/material/InputAdornment';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// // Search Modal Component
// // const SearchModal = ({ open, onClose }) => {
// //   const [searchTerm, setSearchTerm] = useState('');
// //   const [suggestions, setSuggestions] = useState([]);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     const fetchSuggestions = async () => {
// //       if (searchTerm.trim().length < 2) {
// //         setSuggestions([]);
// //         return;
// //       }

// //       setIsLoading(true);
// //       try {
// //         const response = await axios.get(
// //           `https://car.amar.co.jp/api/dashboard/global/search/filter?inputType=${searchTerm}&page=0&size=5`
// //         );
// //         setSuggestions(response.data?.data || []);
// //       } catch (error) {
// //         console.error('Error fetching suggestions:', error);
// //         setSuggestions([]);
// //       } finally {
// //         setIsLoading(false);
// //       }
// //     };

// //     const debounceTimer = setTimeout(fetchSuggestions, 300);
// //     return () => clearTimeout(debounceTimer);
// //   }, [searchTerm]);

// //   const handleSearchSubmit = (e) => {
// //     e.preventDefault();
// //     if (searchTerm.trim()) {
// //       navigate(`/globalSearch?q=${encodeURIComponent(searchTerm)}`);
// //       onClose();
// //     }
// //   };

// //   const handleSuggestionClick = (car) => {
// //     navigate(`/product/${car.carModelId}`);
// //     onClose();
// //   };

// //   return (
// //     <Dialog
// //       open={open}
// //       onClose={onClose}
// //       maxWidth="sm"
// //       fullWidth
// //       sx={{
// //         '& .MuiDialog-paper': {
// //           borderRadius: '8px',
// //           margin: 0,
// //           position: 'absolute',
// //           top: '72px',
// //           width: '70%',
// //           maxWidth: '700px',
// //           maxHeight: 'calc(100vh - 40px)'
// //         }
// //       }}
// //     >
// //       <DialogContent sx={{ p: 2 }}>
// //         <Box component="form" onSubmit={handleSearchSubmit}>
// //           <Paper
// //             sx={{
// //               display: 'flex',
// //               alignItems: 'center',
// //               width: '100%',
// //               border: '1px solid #e0e0e0',
// //               borderRadius: '8px',
// //               boxShadow: 'none',
// //               p: '2px 4px',
// //             }}
// //           >
// //             <InputBase
// //               autoFocus
// //               fullWidth
// //               sx={{
// //                 ml: 1,
// //                 flex: 1,
// //                 fontSize: '14px',
// //                 padding: '6px 0',
// //               }}
// //               placeholder="Search for cars (e.g. Audi)"
// //               value={searchTerm}
// //               onChange={(e) => setSearchTerm(e.target.value)}
// //             />
// //             <IconButton
// //               type="submit"
// //               sx={{
// //                 p: '8px 16px',
// //                 backgroundColor: 'red',
// //                 borderRadius: '6px',
// //                 ml: 1,
// //                 '&:hover': {
// //                   backgroundColor: '#c62828',
// //                 },
// //               }}
// //               aria-label="search"
// //             >
// //               <SearchIcon sx={{ color: 'white', fontSize: 24 }} />
// //             </IconButton>
// //           </Paper>

// //           {searchTerm && (
// //             <Box sx={{
// //               position: 'relative',
// //               width: '100%'
// //             }}>
// //               {isLoading ? (
// //                 <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
// //                   <CircularProgress size={24} />
// //                 </Box>
// //               ) : suggestions.length > 0 ? (
// //                 <Box
// //                   sx={{
// //                     position: 'relative',
// //                     zIndex: 1400,
// //                     backgroundColor: 'white',
// //                     boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
// //                     borderRadius: '0 0 8px 8px',
// //                     maxHeight: '300px',
// //                     overflowY: 'auto',
// //                   }}
// //                 >
// //                   <List dense>
// //                     {suggestions.map((car) => (
// //                       <ListItem
// //                         button
// //                         key={car.carModelId}
// //                         onClick={() => handleSuggestionClick(car)}
// //                         sx={{
// //                           '&:hover': { backgroundColor: '#fafafa' },
// //                           borderBottom: '1px solid #f0f0f0',
// //                           px: 2,
// //                           py: 1,
// //                         }}
// //                       >
// //                         <Box sx={{ width: "100%" }}>
// //                           <Typography variant="subtitle2" fontWeight="bold">
// //                             {car.carBrandName} {car.carModelName}
// //                           </Typography>
// //                           <Box
// //                             sx={{
// //                               display: "flex",
// //                               justifyContent: "space-between",
// //                               fontSize: "12px",
// //                               mt: 0.5,
// //                             }}
// //                           >
// //                             <Typography variant="body2" color="text.secondary">
// //                               {car.carFuel || "N/A"} â€¢ {car.carManufactureDate?.split("-")[0] || "N/A"}
// //                             </Typography>
// //                             <Typography
// //                               variant="body2"
// //                               color="error"
// //                               fontWeight="medium"
// //                             >
// //                               ${car.carPrice?.toLocaleString() || "N/A"}
// //                             </Typography>
// //                           </Box>
// //                         </Box>
// //                       </ListItem>
// //                     ))}
// //                   </List>
// //                 </Box>
// //               ) : (
// //                 <Box
// //                   sx={{
// //                     position: 'relative',
// //                     zIndex: 1400,
// //                     backgroundColor: 'white',
// //                     boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
// //                     borderRadius: '0 0 8px 8px',
// //                     padding: 2,
// //                     textAlign: 'center',
// //                   }}
// //                 >
// //                   <Typography fontSize="14px">
// //                     No results found for "{searchTerm}"
// //                   </Typography>
// //                 </Box>
// //               )}
// //             </Box>
// //           )}
// //         </Box>
// //       </DialogContent>
// //     </Dialog>
// //   );
// // };
// // Replace the SearchModal component with this updated version

// const SearchModal = ({ open, onClose }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [suggestions, setSuggestions] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

//   useEffect(() => {
//     const fetchSuggestions = async () => {
//       if (searchTerm.trim().length < 2) {
//         setSuggestions([]);
//         return;
//       }

//       setIsLoading(true);
//       try {
//         const response = await axios.get(
//           `https://car.amar.co.jp/api/dashboard/global/search/filter?inputType=${searchTerm}&page=0&size=5`
//         );
//         setSuggestions(response.data?.data || []);
//       } catch (error) {
//         console.error('Error fetching suggestions:', error);
//         setSuggestions([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     const debounceTimer = setTimeout(fetchSuggestions, 300);
//     return () => clearTimeout(debounceTimer);
//   }, [searchTerm]);

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     if (searchTerm.trim()) {
//       navigate(`/globalSearch?q=${encodeURIComponent(searchTerm)}`);
//       onClose();
//     }
//   };

//   const handleSuggestionClick = (car) => {
//     navigate(`/product/${car.carModelId}`);
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//       fullWidth
//       sx={{
//         '& .MuiDialog-paper': {
//           borderRadius: '8px',
//           margin: 0,
//           position: 'absolute',
//           top: { xs: '60px', sm: '70px', md: '72px' },
//           width: { xs: '90%', sm: '85%', md: '70%' },
//           maxWidth: { xs: '95vw', sm: '500px', md: '700px' },
//           maxHeight: { xs: 'calc(100vh - 100px)', sm: 'calc(100vh - 80px)', md: 'calc(100vh - 40px)' },
//           // left: { xs: '5%', sm: '7.5%', md: 'auto' },
//           // right: { xs: 'auto', sm: 'auto', md: 0 },
//         }
//       }}
//     >
//       <DialogContent sx={{ p: { xs: 1.5, sm: 2 } }}>
//         <Box component="form" onSubmit={handleSearchSubmit}>
//           <Paper
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               width: '100%',
//               border: '1px solid #e0e0e0',
//               borderRadius: '8px',
//               boxShadow: 'none',
//               // p: { xs: '1px 2px', sm: '2px 4px' },
//             }}
//           >
//             <InputBase
//               autoFocus
//               fullWidth
//               sx={{
//                 ml: 1,
//                 flex: 1,
//                 fontSize: { xs: '12px', sm: '14px' },
//                 // padding: { xs: '4px 0', sm: '6px 0' },
//               }}
//               placeholder="Search for cars (e.g. Audi)"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <IconButton
//               type="submit"
//               sx={{
//                 p: { xs: '6px 12px', sm: '8px 16px' },
//                 backgroundColor: 'red',
//                 borderRadius: '6px',
//                 ml: 1,
//                 flexShrink: 0,
//                 '&:hover': {
//                   backgroundColor: '#c62828',
//                 },
//               }}
//               aria-label="search"
//             >
//               <SearchIcon sx={{ color: 'white', fontSize: { xs: 18, sm: 24 } }} />
//             </IconButton>
//           </Paper>

//           {searchTerm && (
//             <Box sx={{
//               position: 'relative',
//               width: '100%'
//             }}>
//               {isLoading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//                   <CircularProgress size={24} />
//                 </Box>
//               ) : suggestions.length > 0 ? (
//                 <Box
//                   sx={{
//                     position: 'relative',
//                     zIndex: 1400,
//                     backgroundColor: 'white',
//                     boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
//                     borderRadius: '0 0 8px 8px',
//                     maxHeight: { xs: '200px', sm: '300px' },
//                     overflowY: 'auto',
//                   }}
//                 >
//                   <List dense>
//                     {suggestions.map((car) => (
//                       <ListItem
//                         button
//                         key={car.carModelId}
//                         onClick={() => handleSuggestionClick(car)}
//                         sx={{
//                           '&:hover': { backgroundColor: '#fafafa' },
//                           borderBottom: '1px solid #f0f0f0',
//                           px: { xs: 1, sm: 2 },
//                           py: { xs: 0.75, sm: 1 },
//                         }}
//                       >
//                         <Box sx={{ width: "100%" }}>
//                           <Typography variant="subtitle2" fontWeight="bold" sx={{ fontSize: { xs: '0.85rem', sm: '0.95rem' } }}>
//                             {car.carBrandName} {car.carModelName}
//                           </Typography>
//                           <Box
//                             sx={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               fontSize: { xs: "10px", sm: "12px" },
//                               mt: 0.5,
//                             }}
//                           >
//                             <Typography variant="body2" color="text.secondary">
//                               {car.carFuel || "N/A"} • {car.carManufactureDate?.split("-")[0] || "N/A"}
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               color="error"
//                               fontWeight="medium"
//                             >
//                               ${car.carPrice?.toLocaleString() || "N/A"}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Box>
//               ) : (
//                 <Box
//                   sx={{
//                     position: 'relative',
//                     zIndex: 1400,
//                     backgroundColor: 'white',
//                     boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
//                     borderRadius: '0 0 8px 8px',
//                     padding: { xs: 1.5, sm: 2 },
//                     textAlign: 'center',
//                   }}
//                 >
//                   <Typography fontSize={{ xs: '12px', sm: '14px' }}>
//                     No results found for "{searchTerm}"
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           )}
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// const Notes = () => {
//   const [language, setLanguage] = useState("");
//   const [currency, setCurrency] = useState("");
//   const [country, setCountry] = useState("");
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [cartCount, setCartCount] = useState(0);
//   const [itemImages, setItemImages] = useState({});
//   const [value, setValue] = React.useState("1");
//   const location = useLocation();
//   const [openDialog, setOpenDialog] = React.useState(false);
//   const [selectedItem, setSelectedItem] = React.useState(null);
//   const [isMovingToWishlist, setIsMovingToWishlist] = React.useState(false);
//   const [userData, setUser] = useState(null);
//   const dispatch = useDispatch();
//   const user = useSelector((state) => state.user);
//   const { url: profileImageUrl } = useSelector((state) => state.profileImage);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [userName, setUserName] = useState("");
//   const cartState = useSelector(state => state.cart);
//   const navigate = useNavigate();
//   const wishlistState = useSelector(state => state.wishlist);
//   const wishlistItems = wishlistState.items;
//   const wishlistCount = wishlistState.totalItems;
//   const userFromStore = useSelector((state) => state.user);
//   const authCheckRef = useRef(false);
//   const [setWishlistCount] = useState(0);
//   const [setWishlistItems] = useState([]);
//   const [filterState, setFilterState] = useState(null);
//   const { enqueueSnackbar } = useSnackbar();
//   const stateSearchResults = location.state?.searchResults;
//   const stateSearchParams = location.state?.searchParams;
//   const [searchModalOpen, setSearchModalOpen] = useState(false);
//   const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
//   const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [userState, setUserState] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const timeoutRef = useRef(null);
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery('(max-width:900px)');

//   useEffect(() => {
//     dispatch(fetchWishlist());
//   }, [dispatch]);

//   useEffect(() => {
//     return () => {
//       localStorage.removeItem('filterState');
//     };
//   }, []);

//   const handleMobileMenuOpen = (event) => {
//     setMobileMenuAnchor(event.currentTarget);
//   };

//   const handleMobileMenuClose = () => {
//     setMobileMenuAnchor(null);
//   };

//   const handleMobileMenuNavigate = (path) => {
//     navigate(path);
//     handleMobileMenuClose();
//   };

//   const handleAddToWishlist = async (modelId) => {
//     const result = await dispatch(addToWishlist(modelId));
//     if (result.success) {
//       enqueueSnackbar("Added to wishlist successfully", { variant: 'success' });
//     } else if (result.alreadyInWishlist) {
//       enqueueSnackbar("This item is already in your wishlist", { variant: 'info' });
//     } else {
//       enqueueSnackbar(result.message || "Failed to add to wishlist", { variant: 'error' });
//     }
//   };

//   useEffect(() => {
//     const stateFromNavigation = location.state?.filterState;
//     const stateFromStorage = JSON.parse(localStorage.getItem('filterState'));

//     if (stateFromNavigation || stateFromStorage) {
//       setFilterState(stateFromNavigation || stateFromStorage);
//     }
//   }, [location.state]);

//   const renderFilterChips = () => {
//     if (!filterState) return null;

//     return (
//       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//         {filterState.selectedCategory && (
//           <Chip
//             label={`Body: ${filterState.selectedCategory.label}`}
//             onDelete={() => { }}
//           />
//         )}
//         {filterState.selectedBrand && (
//           <Chip
//             label={`Brand: ${filterState.selectedBrand.label}`}
//             onDelete={() => { }}
//           />
//         )}
//         {filterState.selectedModels.length > 0 && (
//           <Chip
//             label={`Models: ${filterState.selectedModels.map(m => m.carModelName).join(', ')}`}
//             onDelete={() => { }}
//           />
//         )}
//         {filterState.selectedYears.length > 0 && (
//           <Chip
//             label={`Years: ${filterState.selectedYears.map(y => y.year).join(', ')}`}
//             onDelete={() => { }}
//           />
//         )}
//       </Box>
//     );
//   };

//   const handleRemoveFromWishlist = async (modelId) => {
//     const result = await dispatch(removeFromWishlist(modelId));
//     if (result.success) {
//       enqueueSnackbar("Removed from wishlist successfully", { variant: 'success' });
//     } else {
//       enqueueSnackbar(result.message || "Failed to remove from wishlist", { variant: 'error' });
//     }
//   };

//   useEffect(() => {
//     setCartItems(cartState.items);
//     setCartCount(cartState.totalItems);
//   }, [cartState]);

//   const tabHandleChangess = (event, newValue) => {
//     setValue(newValue);
//   };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
//       return;
//     }
//     setDrawerOpen(open);
//   };

//   const handleCloseIfComplete = () => {
//     if (language && currency && country) {
//       setDrawerOpen(false);
//     }
//   };

//   const handleChangeLanguage = (event) => {
//     setLanguage(event.target.value);
//     handleCloseIfComplete();
//   };

//   const handleChangeCurrency = (event) => {
//     setCurrency(event.target.value);
//     handleCloseIfComplete();
//   };

//   const handleChangeCountry = (event) => {
//     setCountry(event.target.value);
//     handleCloseIfComplete();
//   };

//   useEffect(() => {
//     if (!authCheckRef.current) {
//       checkAuthToken();
//       authCheckRef.current = true;
//     }

//     if (currentUser) {
//       dispatch(fetchProfileImage());
//     }
//   }, [dispatch, currentUser]);

//   const checkAuthToken = async () => {
//     const token = localStorage.getItem("authToken");

//     if (token) {
//       try {
//         const response = await fetch(
//           "https://car.amar.co.jp/api/authorization/user/get/user/details",
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (response.ok) {
//           const data = await response.json();
//           setCurrentUser(data.userDetails);
//         } else {
//           localStorage.removeItem("authToken");
//           setCurrentUser(null);
//         }
//       } catch (error) {
//         console.error("Error fetching user details:", error);
//       }
//     }
//   };

//   const getInitials = (fullName) => {
//     if (!fullName) return "";
//     const parts = fullName.trim().split(" ");
//     return parts.length > 1
//       ? parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
//       : parts[0][0].toUpperCase();
//   };

//   const handleChangess = (event, newValue) => {
//     setValue(newValue);
//   };

//   const fetchItemImage = async (modelId) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         console.error("No authentication token found");
//         return null;
//       }

//       const response = await fetch(
//         `https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${modelId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.ok) {
//         const blob = await response.blob();
//         return URL.createObjectURL(blob);
//       } else {
//         console.error(`Failed to fetch image for model ${modelId}`);
//         return null;
//       }
//     } catch (error) {
//       console.error(`Error fetching image for model ${modelId}:`, error);
//       return null;
//     }
//   };

//   const fetchCartData = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       if (!token) {
//         console.error("No authentication token found. Please log in.");
//         return;
//       }

//       const response = await fetch(
//         "https://car.amar.co.jp/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART",
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.code === 200) {
//         setCartItems(data.items);
//         setCartCount(data.totalItems);

//         const imagePromises = data.items.map(async (item) => {
//           const imageUrl = await fetchItemImage(item.modelId);
//           return { modelId: item.modelId, imageUrl };
//         });

//         const imagesResults = await Promise.all(imagePromises);

//         const imagesObject = imagesResults.reduce((acc, curr) => {
//           if (curr.imageUrl) {
//             acc[curr.modelId] = curr.imageUrl;
//           }
//           return acc;
//         }, {});

//         setItemImages(imagesObject);

//       } else {
//         console.error("Failed to fetch cart data:", data.message);
//       }
//     } catch (error) {
//       console.error("Error fetching cart data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchCartData();
//   }, []);

//   useEffect(() => {
//     const fetchUserDetails = async () => {
//       try {
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//           console.error("No authentication token found. Please log in.");
//           return;
//         }

//         const response = await fetch(
//           "https://car.amar.co.jp/api/authorization/user/get/user/details",
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (response.ok) {
//           const data = await response.json();
//           setUserState(data.userDetails);
//         } else {
//           console.error("Failed to fetch user details");
//         }
//       } catch (error) {
//         console.error("Error fetching user details:", error);
//       }
//     };

//     fetchUserDetails();
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("authToken");
//     dispatch(clearCart());
//     dispatch(clearWishlist());
//     setCartItems([]);
//     setCartCount(0);
//     setItemImages({});
//     setUserState(null);
//     setCurrentUser(null);
//     navigate("/login");
//   };

//   const handleMouseEnter = (event) => {
//     clearTimeout(timeoutRef.current);
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuMouseEnter = () => {
//     clearTimeout(timeoutRef.current);
//   };

//   const handleMouseLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setAnchorEl(null);
//     }, 100);
//   };

//   const handleLoginClick = () => {
//     if (!userState) {
//       navigate("/login");
//     }
//   };

//   const handleProfileNavigation = () => {
//     setAnchorEl(null);
//     if (!currentUser) {
//       navigate("/MyAccount");
//     }
//   };

//   const shippingFee = 32.21;
//   const total = cartItems.reduce((sum, item) => sum + item.price, 0);
//   const removeItem = (itemId) => {
//     setCartItems((prevItems) => {
//       const updatedCart = prevItems.filter((item) => item.modelId !== itemId);
//       return updatedCart.length > 0 ? updatedCart : [];
//     });
//   };

//   const handleDeleteClick = (item) => {
//     setSelectedItem(item);
//     setOpenDialog(true);
//   };

//   const handleConfirmDelete = async () => {
//     if (selectedItem) {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//           console.error("No authentication token found. Please log in.");
//           return;
//         }

//         const response = await fetch(
//           `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${selectedItem.modelId}`,
//           {
//             method: "DELETE",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (response.ok) {
//           setCartItems((prevItems) => {
//             const updatedCart = prevItems.filter((item) => item.modelId !== selectedItem.modelId);
//             return updatedCart;
//           });

//           setCartCount((prevCount) => Math.max(0, prevCount - 1));

//           setItemImages((prevImages) => {
//             const updatedImages = { ...prevImages };
//             delete updatedImages[selectedItem.modelId];
//             return updatedImages;
//           });
//         } else {
//           console.error("Failed to delete item from the server.");
//         }
//       } catch (error) {
//         console.error("Error deleting item:", error);
//       }
//     }
//     setSelectedItem(null);
//     setOpenDialog(false);
//   };

//   const handleMoveToWishlist = async () => {
//     if (selectedItem) {
//       setIsMovingToWishlist(true);
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//           console.error("No authentication token found. Please log in.");
//           setIsMovingToWishlist(false);
//           return;
//         }

//         const response = await fetch(
//           `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${selectedItem.modelId}&SelectType=MOVE_TO_WISHLIST`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const data = await response.json();

//         if (response.ok && data.code === 200) {
//           setCartItems((prevItems) => {
//             const updatedCart = prevItems.filter((item) => item.modelId !== selectedItem.modelId);
//             return updatedCart;
//           });

//           setCartCount((prevCount) => Math.max(0, prevCount - 1));

//           setItemImages((prevImages) => {
//             const updatedImages = { ...prevImages };
//             delete updatedImages[selectedItem.modelId];
//             return updatedImages;
//           });

//           dispatch(fetchCart());
//           dispatch(fetchWishlist());

//           enqueueSnackbar("Item moved to wishlist successfully", { variant: 'success' });
//         } else {
//           console.error("Failed to move item to wishlist:", data.message);
//           enqueueSnackbar("Failed to move item to wishlist", { variant: 'error' });
//         }
//       } catch (error) {
//         console.error("Error moving item to wishlist:", error);
//         enqueueSnackbar("Error moving item to wishlist", { variant: 'error' });
//       } finally {
//         setIsMovingToWishlist(false);
//         setOpenDialog(false);
//         setSelectedItem(null);
//       }
//     }
//   };

//   const iconWrapperStyle = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     textAlign: "center",
//     cursor: "pointer",
//     minWidth: 60,
//   };

//   return (
//     <div className="main-container">
//       <Box
//         sx={{
//           // position: { xs: "relative", md: "fixed" },
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 1200,
//           backgroundColor: "white",
//           boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
//           transition: "top 0.3s ease",
//           width: "100%",
//           transform: "translateY(0)",
//         }}
//       >
//         <Box
//           sx={{
//             flexGrow: 1,
//             px: { xs: 1.5, sm: 2.5, md: 3 },
//             py: 1.3,
//             borderBottom: "1px solid #e0e0e0",
//             backgroundColor: "#fff",
//             boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//           }}
//         >
//           <Grid container alignItems="center" justifyContent="space-between" spacing={{ xs: 1, sm: 2 }}>
//             {/* Logo */}
//             <Grid
//               item
//               xs={6}
//               sm={4}
//               md={3}
//               lg={2}
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: { xs: 0.5, sm: 1 },
//               }}
//             >
//               {/* Filter Icon - Only visible on screens below 900px */}
//               {isTablet && (
//                 <Box
//                   onClick={() => setFilterDrawerOpen(!filterDrawerOpen)}
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     cursor: "pointer",
//                     p: { xs: 0.3, sm: 0.75 },
//                     borderRadius: 1,
//                     transition: "all 0.2s ease",
//                     backgroundColor: filterDrawerOpen ? "rgba(220, 53, 69, 0.1)" : "transparent",
//                     minWidth: { xs: 36, sm: 44 },
//                     minHeight: { xs: 36, sm: 44 },
//                     "&:hover": {
//                       backgroundColor: "rgba(220, 53, 69, 0.1)",
//                       "& svg": { color: "#dc3545" },
//                     },
//                   }}
//                 >
//                   <TuneIcon sx={{ fontSize: { xs: 22, sm: 24 }, color: filterDrawerOpen ? "#dc3545" : "inherit" }} />
//                 </Box>
//               )}
//               <Box
//                 component="img"
//                 src={logo}
//                 alt="Logo"
//                 onClick={() => navigate("/")}
//                 sx={{
//                   maxWidth: { xs: "120px", sm: "150px" },
//                   width: "100%",
//                   cursor: "pointer",
//                   transition: "opacity 0.3s ease",
//                   "&:hover": { opacity: 0.8 },
//                 }}
//               />
//             </Grid>

//             {/* Desktop Navigation */}
//             <Grid
//               item
//               md={6}
//               lg={7}
//               sx={{
//                 display: { xs: "none", md: "flex" },
//                 gap: { md: 1, lg: 2 },
//               }}
//             >
//               {[
//                 { label: "About Us", path: "/aboutUs" },
//                 { label: "Contact", path: "/contactUs" },
//                 { label: "Purchase Flow", path: "/purchaseFlow" },
//               ].map((item) => (
//                 <Button
//                   key={item.path}
//                   onClick={() => navigate(item.path)}
//                   sx={{
//                     color: "#333",
//                     fontSize: { md: "0.9rem", lg: "1rem" },
//                     fontWeight: 500,
//                     textTransform: "none",
//                     whiteSpace: "nowrap",
//                     position: "relative",
//                     "&::after": {
//                       content: '""',
//                       position: "absolute",
//                       width: 0,
//                       height: "2px",
//                       bottom: 0,
//                       left: 0,
//                       backgroundColor: "#dc3545",
//                       transition: "width 0.3s ease",
//                     },
//                     "&:hover::after": {
//                       width: "100%",
//                     },
//                   }}
//                 >
//                   {item.label}
//                 </Button>
//               ))}
//             </Grid>

//             {/* Icons Section */}
//             <Grid
//               item
//               xs={6}
//               sm={8}
//               md={3}
//               lg={3}
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: { xs: "flex-end", sm: "space-around" },
//                 gap: { xs: 0.2, sm: 1.5, md: 2 },
//               }}
//             >

//               {/* Search Icon */}
//               <Box
//                 onClick={() => setSearchModalOpen(true)}
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   p: { xs: 0.3, sm: 0.75 },
//                   borderRadius: 1,
//                   transition: "all 0.2s ease",
//                   minWidth: { xs: 36, sm: 44 },
//                   minHeight: { xs: 36, sm: 44 },
//                   "&:hover": {
//                     backgroundColor: "rgba(220, 53, 69, 0.1)",
//                     "& svg": { color: "#dc3545" },
//                   },
//                 }}
//               >
//                 <SearchIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
//                 <Typography
//                   sx={{
//                     fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
//                     mt: 0.3,
//                     display: { xs: "none", lg: "block" },
//                     fontWeight: 500,
//                   }}
//                 >
//                   Search
//                 </Typography>
//               </Box>

//               {/* Wishlist Icon */}
//               <Box
//                 onClick={() => navigate("/myAccount/wishlist")}
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   p: { xs: 0.3, sm: 0.75 },
//                   borderRadius: 1,
//                   transition: "all 0.2s ease",
//                   minWidth: { xs: 36, sm: 44 },
//                   minHeight: { xs: 36, sm: 44 },
//                   "&:hover": {
//                     backgroundColor: "rgba(220, 53, 69, 0.1)",
//                     "& svg": { color: "#dc3545" },
//                   },
//                 }}
//               >
//                 <Badge badgeContent={wishlistCount} color="error" overlap="circular" sx={{ '& .MuiBadge-badge': { minWidth: 16, height: 16, fontSize: '10px', padding: '0 4px' } }}>
//                   <FavoriteIcon sx={{ fontSize: { xs: 18, sm: 24 }, color: "#dc3545" }} />
//                 </Badge>
//                 <Typography
//                   sx={{
//                     fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
//                     mt: 0.3,
//                     display: { xs: "none", lg: "block" },
//                     fontWeight: 500,
//                   }}
//                 >
//                   Wishlist
//                 </Typography>
//               </Box>

//               {/* Cart Icon */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   p: { xs: 0.3, sm: 0.75 },
//                   borderRadius: 1,
//                   transition: "all 0.2s ease",
//                   minWidth: { xs: 36, sm: 44 },
//                   minHeight: { xs: 36, sm: 44 },
//                   "&:hover": {
//                     backgroundColor: "rgba(220, 53, 69, 0.1)",
//                     "& svg": { color: "#dc3545" },
//                   },
//                 }}
//                 onClick={() => {
//                   if (!isOpen) {
//                     setIsOpen(true);
//                     fetchCartData();
//                   }
//                 }}
//               >
//                 <Badge badgeContent={cartCount} color="error" overlap="circular" sx={{ '& .MuiBadge-badge': { minWidth: 16, height: 16, fontSize: '10px', padding: '0 4px' } }}>
//                   <LocalMallOutlinedIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
//                 </Badge>
//                 <Typography
//                   sx={{
//                     fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
//                     mt: 0.3,
//                     display: { xs: "none", lg: "block" },
//                     fontWeight: 500,
//                   }}
//                 >
//                   Cart
//                 </Typography>

//                 {/* Cart Drawer */}
//                 <Drawer
//                   anchor="right"
//                   open={isOpen}
//                   onClose={() => setIsOpen(false)}
//                   slotProps={{
//                     paper: {
//                       sx: {
//                         width: { xs: "100%", sm: 400, md: 450 },
//                         display: "flex",
//                         flexDirection: "column",
//                       },
//                     },
//                   }}
//                   ModalProps={{
//                     keepMounted: false,
//                     onBackdropClick: () => setIsOpen(false),
//                   }}
//                 >
//                   {/* Cart Header */}
//                   <Box
//                     sx={{
//                       p: 2,
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       borderBottom: "1px solid #e0e0e0",
//                     }}
//                   >
//                     <Typography variant="h6" sx={{ fontWeight: 700, color: "#333" }}>
//                       My Shopping Cart ({cartCount})
//                     </Typography>
//                     <IconButton
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setIsOpen(false);
//                       }}
//                       size="small"
//                       sx={{ "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" } }}
//                     >
//                       <CloseIcon />
//                     </IconButton>
//                   </Box>

//                   {/* Cart Items */}
//                   <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
//                     {cartItems.length > 0 ? (
//                       <List sx={{ p: 0 }}>
//                         {cartItems.map((item) => (
//                           <ListItem
//                             key={item.id}
//                             sx={{
//                               display: "flex",
//                               gap: 1.5,
//                               mb: 2,
//                               p: 1,
//                               borderRadius: 1,
//                               backgroundColor: "#f9f9f9",
//                               transition: "background-color 0.2s",
//                               "&:hover": { backgroundColor: "#f5f5f5" },
//                             }}
//                           >
//                             <Link
//                               to={`/product/${item.modelId}`}
//                               style={{
//                                 display: "flex",
//                                 textDecoration: "none",
//                                 color: "inherit",
//                                 flex: 1,
//                                 gap: 12,
//                               }}
//                             >
//                               <Box
//                                 component="img"
//                                 src={itemImages[item.modelId] || "/placeholder.jpg"}
//                                 alt={item.modelName}
//                                 sx={{
//                                   width: 80,
//                                   height: 60,
//                                   borderRadius: 1,
//                                   objectFit: "cover",
//                                   backgroundColor: "#f0f0f0",
//                                   flexShrink: 0,
//                                 }}
//                               />
//                               <Box sx={{ flex: 1, minWidth: 0 }}>
//                                 <Typography
//                                   variant="subtitle2"
//                                   sx={{
//                                     fontWeight: 600,
//                                     color: "#333",
//                                     mb: 0.5,
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     whiteSpace: "nowrap",
//                                   }}
//                                 >
//                                   {item.brand} {item.modelName}
//                                 </Typography>
//                                 <Typography
//                                   variant="body2"
//                                   sx={{
//                                     color: "#dc3545",
//                                     fontWeight: 600,
//                                   }}
//                                 >
//                                   ${item.price}
//                                 </Typography>
//                               </Box>
//                             </Link>
//                             <IconButton
//                               onClick={() => handleDeleteClick(item)}
//                               size="small"
//                               sx={{
//                                 color: "#dc3545",
//                                 "&:hover": { backgroundColor: "rgba(220, 53, 69, 0.1)" },
//                               }}
//                             >
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </ListItem>
//                         ))}
//                       </List>
//                     ) : (
//                       <Box
//                         sx={{
//                           display: "flex",
//                           flexDirection: "column",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           height: "100%",
//                           py: 4,
//                         }}
//                       >
//                         <ShoppingBagOutlinedIcon
//                           sx={{ fontSize: 56, color: "#ddd", mb: 2 }}
//                         />
//                         <Typography
//                           variant="subtitle1"
//                           sx={{ fontWeight: 600, color: "#666", mb: 0.5 }}
//                         >
//                           Your Cart is Empty
//                         </Typography>
//                         <Typography variant="caption" sx={{ color: "#999" }}>
//                           No items in your shopping cart yet
//                         </Typography>
//                       </Box>
//                     )}
//                   </Box>

//                   {/* Cart Footer */}
//                   {cartItems.length > 0 && (
//                     <Box
//                       sx={{
//                         p: 2,
//                         borderTop: "1px solid #e0e0e0",
//                         backgroundColor: "#fff",
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: 1.5,
//                       }}
//                     >
//                       <Box display="flex" gap={1}>
//                         <TextField
//                           placeholder="Coupon Code"
//                           variant="outlined"
//                           size="small"
//                           fullWidth
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               fontSize: "0.9rem",
//                               "&:hover fieldset": { borderColor: "#dc3545" },
//                               "&.Mui-focused fieldset": { borderColor: "#dc3545" },
//                             },
//                           }}
//                         />
//                         <Button
//                           variant="outlined"
//                           sx={{
//                             borderColor: "#dc3545",
//                             color: "#dc3545",
//                             fontWeight: 600,
//                             minWidth: 90,
//                             textTransform: "none",
//                             "&:hover": {
//                               backgroundColor: "rgba(220, 53, 69, 0.1)",
//                               borderColor: "#dc3545",
//                             },
//                           }}
//                         >
//                           Apply
//                         </Button>
//                       </Box>

//                       <Box>
//                         <Box display="flex" justifyContent="space-between" sx={{ mb: 1.5 }}>
//                           <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                             Total
//                           </Typography>
//                           <Typography
//                             variant="subtitle1"
//                             sx={{ fontWeight: 700, color: "#dc3545" }}
//                           >
//                             ${total.toFixed(2)}
//                           </Typography>
//                         </Box>
//                       </Box>

//                       <Button
//                         variant="contained"
//                         fullWidth
//                         onClick={() => {
//                           navigate("/delivery");
//                           setIsOpen(false);
//                         }}
//                         sx={{
//                           backgroundColor: "#dc3545",
//                           color: "white",
//                           fontWeight: 600,
//                           textTransform: "none",
//                           py: 1.2,
//                           "&:hover": { backgroundColor: "#c82333" },
//                         }}
//                       >
//                         Proceed to Checkout
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         fullWidth
//                         onClick={() => setIsOpen(false)}
//                         sx={{
//                           borderColor: "#e0e0e0",
//                           color: "#333",
//                           fontWeight: 600,
//                           textTransform: "none",
//                           py: 1.2,
//                           "&:hover": { backgroundColor: "#f9f9f9" },
//                         }}
//                       >
//                         Continue Shopping
//                       </Button>
//                     </Box>
//                   )}
//                 </Drawer>

//                 {/* Delete Dialog */}
//                 <Dialog
//                   open={openDialog}
//                   onClose={() => setOpenDialog(false)}
//                   slotProps={{
//                     paper: { sx: { minWidth: 300 } },
//                   }}
//                 >
//                   <DialogTitle sx={{ fontWeight: 700 }}>Item Options</DialogTitle>
//                   <DialogContent>
//                     <DialogContentText sx={{ my: 2 }}>
//                       What would you like to do?
//                     </DialogContentText>
//                   </DialogContent>
//                   <DialogActions sx={{ p: 2 }}>
//                     <Button
//                       onClick={handleMoveToWishlist}
//                       disabled={isMovingToWishlist}
//                       sx={{
//                         textTransform: "none",
//                         fontWeight: 600,
//                         color: "#dc3545",
//                       }}
//                     >
//                       {isMovingToWishlist ? (
//                         <CircularProgress size={20} sx={{ mr: 1 }} />
//                       ) : (
//                         "Move to Wishlist"
//                       )}
//                     </Button>
//                     <Button
//                       onClick={handleConfirmDelete}
//                       variant="contained"
//                       sx={{
//                         backgroundColor: "#dc3545",
//                         textTransform: "none",
//                         fontWeight: 600,
//                         "&:hover": { backgroundColor: "#c82333" },
//                       }}
//                     >
//                       Delete
//                     </Button>
//                   </DialogActions>
//                 </Dialog>
//               </Box>

//               {/* Profile/Login Icon */}
//               <Box
//                 onMouseEnter={handleMouseEnter}
//                 onMouseLeave={handleMouseLeave}
//                 onClick={() => {
//                   if (!currentUser) {
//                     navigate("/login");
//                   }
//                 }}
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   cursor: "pointer",
//                   p: { xs: 1, sm: 0.75 },
//                   borderRadius: 1,
//                   transition: "all 0.2s ease",
//                   minWidth: { xs: 36, sm: 44 },
//                   minHeight: { xs: 36, sm: 44 },
//                   "&:hover": {
//                     backgroundColor: "rgba(0,0,0,0.05)",
//                   },
//                 }}
//               >
//                 {currentUser ? (
//                   <>
//                     <Avatar
//                       src={profileImageUrl}
//                       alt={currentUser.firstName}
//                       sx={{
//                         width: { xs: 24, sm: 28 },
//                         height: { xs: 24, sm: 28 },
//                         fontSize: "0.75rem",
//                         backgroundColor: "#dc3545",
//                         flexShrink: 0,
//                       }}
//                       onError={(e) => {
//                         console.error("Header image failed to load");
//                         e.target.src = "";
//                       }}
//                     >
//                       {getInitials(`${currentUser.firstName} ${currentUser.lastName || ""}`)}
//                     </Avatar>
//                     <Typography
//                       sx={{
//                         fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
//                         // mt: 0.3,
//                         display: { xs: "none", lg: "block" },
//                         fontWeight: 500,
//                         maxWidth: "80px",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {currentUser.firstName}
//                     </Typography>
//                   </>
//                 ) : (
//                   <>
//                     <PermIdentityIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
//                     <Typography
//                       sx={{
//                         fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
//                         mt: 0.3,
//                         display: { xs: "none", lg: "block" },
//                         fontWeight: 500,
//                       }}
//                     >
//                       Login
//                     </Typography>
//                   </>
//                 )}

//                 {/* Profile Menu */}
//                 <Menu
//                   anchorEl={anchorEl}
//                   open={Boolean(anchorEl)}
//                   onClose={() => setAnchorEl(null)}
//                   MenuListProps={{
//                     onMouseEnter: handleMenuMouseEnter,
//                     onMouseLeave: handleMouseLeave,
//                   }}
//                   anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//                   transformOrigin={{ vertical: "top", horizontal: "right" }}
//                   disableScrollLock={true}
//                   slotProps={{
//                     paper: {
//                       sx: {
//                         mt: 1,
//                         minWidth: currentUser ? 280 : 240,
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
//                       },
//                     },
//                   }}
//                 >
//                   {!currentUser ? (
//                     <Box sx={{ p: 2 }}>
//                       <Typography variant="body2" sx={{ mb: 1.5 }}>
//                         <strong>New Customer?</strong>{" "}
//                         <span
//                           style={{
//                             color: "#dc3545",
//                             cursor: "pointer",
//                             fontWeight: 600,
//                             textDecoration: "underline",
//                           }}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setAnchorEl(null);
//                             navigate("/signup");
//                           }}
//                         >
//                           Sign Up
//                         </span>
//                       </Typography>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/about-us");
//                         }}
//                         sx={{ fontSize: "0.95rem" }}
//                       >
//                         About Us
//                       </MenuItem>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/contact-us");
//                         }}
//                         sx={{ fontSize: "0.95rem" }}
//                       >
//                         Contact Us
//                       </MenuItem>
//                     </Box>
//                   ) : (
//                     <Box sx={{ p: 0 }}>
//                       {/* Profile Header */}
//                       <Box
//                         sx={{
//                           p: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                           backgroundColor: "#f9f9f9",
//                           borderBottom: "1px solid #e0e0e0",
//                           cursor: "pointer",
//                           transition: "background-color 0.2s",
//                           "&:hover": { backgroundColor: "#f0f0f0" },
//                         }}
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount");
//                         }}
//                       >
//                         <Avatar
//                           src={profileImageUrl}
//                           alt={currentUser.firstName}
//                           sx={{
//                             width: 44,
//                             height: 44,
//                             backgroundColor: "#dc3545",
//                             fontSize: "1.1rem",
//                             flexShrink: 0,
//                           }}
//                         >
//                           {getInitials(
//                             `${currentUser.firstName} ${currentUser.lastName || ""}`
//                           )}
//                         </Avatar>
//                         <Box sx={{ minWidth: 0, flex: 1 }}>
//                           <Typography
//                             variant="subtitle2"
//                             sx={{
//                               fontWeight: 700,
//                               color: "#333",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {currentUser.firstName} {currentUser.lastName || ""}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: "#999",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap",
//                               display: "block",
//                             }}
//                           >
//                             {currentUser.email}
//                           </Typography>
//                         </Box>
//                       </Box>

//                       {/* Menu Items */}
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                         }}
//                       >
//                         <AccountBalanceIcon sx={{ color: "#dc3545", fontSize: 20 }} />
//                         <span>My Account</span>
//                       </MenuItem>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount/myProfile");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                         }}
//                       >
//                         <PermIdentityIcon sx={{ color: "#dc3545", fontSize: 20 }} />
//                         <span>My Profile</span>
//                       </MenuItem>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount/orderHistory");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                         }}
//                       >
//                         <LocalMallOutlinedIcon sx={{ color: "#dc3545", fontSize: 20 }} />
//                         <span>Order History</span>
//                       </MenuItem>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount/inquiryHistory");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                         }}
//                       >
//                         <Box
//                           component="img"
//                           src="/image/Invoice.svg"
//                           alt="inquiry"
//                           sx={{ width: 20, height: 20 }}
//                         />
//                         <span>Inquiry History</span>
//                       </MenuItem>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount/wishlist");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                         }}
//                       >
//                         <Box
//                           component="img"
//                           src="/image/heart.svg"
//                           alt="wishlist"
//                           sx={{ width: 20, height: 20 }}
//                         />
//                         <span>My Wishlist</span>
//                       </MenuItem>
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           navigate("/myAccount/myAddress");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                         }}
//                       >
//                         <Box
//                           component="img"
//                           src="/image/address.svg"
//                           alt="Address Icon"
//                           sx={{ width: 20, height: 20 }}
//                         />
//                         <span>My Address</span>
//                       </MenuItem>

//                       <Divider sx={{ my: 1 }} />
//                       <MenuItem
//                         onClick={() => {
//                           setAnchorEl(null);
//                           handleLogout();
//                           navigate("/login");
//                         }}
//                         sx={{
//                           fontSize: "0.95rem",
//                           py: 1.2,
//                           px: 2,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                           color: "#dc3545",
//                         }}
//                       >
//                         <LogoutOutlinedIcon sx={{ color: "#dc3545", fontSize: 20 }} />
//                         <span>Logout</span>
//                       </MenuItem>
//                     </Box>
//                   )}
//                 </Menu>
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>

//         {/* Filter Section - Shows Below Header on Tablet */}
//         {isTablet && filterDrawerOpen && (
//           <Box
//             sx={{
//               px: { xs: 1.5, sm: 2.5, md: 3 },
//               py: 2,
//               borderBottom: "1px solid #e0e0e0",
//               backgroundColor: "#fff",
//               width: "100%",
//             }}
//           >
//             <BasicSelectFilter initialFilterState={filterState} />
//           </Box>
//         )}

//         {/* BasicSelectFilter - Only visible on screens 900px and above */}
//         {!isTablet && (
//           <Box sx={{ display: 'block' }}>
//             <BasicSelectFilter initialFilterState={filterState} />
//           </Box>
//         )}
//       </Box>

//       {/* <Toolbar sx={{ display: { xs: 'none', md: 'block' } }} /> */}
//       <Toolbar sx={{ display: 'block' }} />  
//       <SearchModal
//         open={searchModalOpen}
//         onClose={() => setSearchModalOpen(false)}
//       />
//     </div>
//   );
// };

// export default Notes;








import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./header.css";
import logo from "../logo.png";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import TuneIcon from "@mui/icons-material/Tune";
import Grid from "@mui/material/Grid";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import { Toolbar, Typography, Box, CircularProgress, useTheme, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Drawer, IconButton, List, ListItem, ListItemText, Button, Menu, Divider, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Chip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import { fetchCart, fetchWishlist, addToWishlist, removeFromWishlist, fetchProfileImage, setProfileImage, clearCart, clearWishlist } from './store';
import { useDispatch, useSelector } from 'react-redux';
import BasicSelectFilter from "./filter";
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import axios from 'axios';
import InputAdornment from '@mui/material/InputAdornment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// Search Modal Component
// const SearchModal = ({ open, onClose }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [suggestions, setSuggestions] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchSuggestions = async () => {
//       if (searchTerm.trim().length < 2) {
//         setSuggestions([]);
//         return;
//       }

//       setIsLoading(true);
//       try {
//         const response = await axios.get(
//           `https://car.amar.co.jp/api/dashboard/global/search/filter?inputType=${searchTerm}&page=0&size=5`
//         );
//         setSuggestions(response.data?.data || []);
//       } catch (error) {
//         console.error('Error fetching suggestions:', error);
//         setSuggestions([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     const debounceTimer = setTimeout(fetchSuggestions, 300);
//     return () => clearTimeout(debounceTimer);
//   }, [searchTerm]);

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     if (searchTerm.trim()) {
//       navigate(`/globalSearch?q=${encodeURIComponent(searchTerm)}`);
//       onClose();
//     }
//   };

//   const handleSuggestionClick = (car) => {
//     navigate(`/product/${car.carModelId}`);
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//       fullWidth
//       sx={{
//         '& .MuiDialog-paper': {
//           borderRadius: '8px',
//           margin: 0,
//           position: 'absolute',
//           top: '72px',
//           width: '70%',
//           maxWidth: '700px',
//           maxHeight: 'calc(100vh - 40px)'
//         }
//       }}
//     >
//       <DialogContent sx={{ p: 2 }}>
//         <Box component="form" onSubmit={handleSearchSubmit}>
//           <Paper
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               width: '100%',
//               border: '1px solid #e0e0e0',
//               borderRadius: '8px',
//               boxShadow: 'none',
//               p: '2px 4px',
//             }}
//           >
//             <InputBase
//               autoFocus
//               fullWidth
//               sx={{
//                 ml: 1,
//                 flex: 1,
//                 fontSize: '14px',
//                 padding: '6px 0',
//               }}
//               placeholder="Search for cars (e.g. Audi)"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <IconButton
//               type="submit"
//               sx={{
//                 p: '8px 16px',
//                 backgroundColor: 'red',
//                 borderRadius: '6px',
//                 ml: 1,
//                 '&:hover': {
//                   backgroundColor: '#c62828',
//                 },
//               }}
//               aria-label="search"
//             >
//               <SearchIcon sx={{ color: 'white', fontSize: 24 }} />
//             </IconButton>
//           </Paper>

//           {searchTerm && (
//             <Box sx={{
//               position: 'relative',
//               width: '100%'
//             }}>
//               {isLoading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//                   <CircularProgress size={24} />
//                 </Box>
//               ) : suggestions.length > 0 ? (
//                 <Box
//                   sx={{
//                     position: 'relative',
//                     zIndex: 1400,
//                     backgroundColor: 'white',
//                     boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
//                     borderRadius: '0 0 8px 8px',
//                     maxHeight: '300px',
//                     overflowY: 'auto',
//                   }}
//                 >
//                   <List dense>
//                     {suggestions.map((car) => (
//                       <ListItem
//                         button
//                         key={car.carModelId}
//                         onClick={() => handleSuggestionClick(car)}
//                         sx={{
//                           '&:hover': { backgroundColor: '#fafafa' },
//                           borderBottom: '1px solid #f0f0f0',
//                           px: 2,
//                           py: 1,
//                         }}
//                       >
//                         <Box sx={{ width: "100%" }}>
//                           <Typography variant="subtitle2" fontWeight="bold">
//                             {car.carBrandName} {car.carModelName}
//                           </Typography>
//                           <Box
//                             sx={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               fontSize: "12px",
//                               mt: 0.5,
//                             }}
//                           >
//                             <Typography variant="body2" color="text.secondary">
//                               {car.carFuel || "N/A"} â€¢ {car.carManufactureDate?.split("-")[0] || "N/A"}
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               color="error"
//                               fontWeight="medium"
//                             >
//                               ${car.carPrice?.toLocaleString() || "N/A"}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Box>
//               ) : (
//                 <Box
//                   sx={{
//                     position: 'relative',
//                     zIndex: 1400,
//                     backgroundColor: 'white',
//                     boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
//                     borderRadius: '0 0 8px 8px',
//                     padding: 2,
//                     textAlign: 'center',
//                   }}
//                 >
//                   <Typography fontSize="14px">
//                     No results found for "{searchTerm}"
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           )}
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };
// Replace the SearchModal component with this updated version

const SearchModal = ({ open, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (searchTerm.trim().length < 2) {
        setSuggestions([]);
        return;
      }

      setIsLoading(true);
      try {
        const response = await axios.get(
          `https://car.amar.co.jp/api/dashboard/global/search/filter?inputType=${searchTerm}&page=0&size=5`
        );
        setSuggestions(response.data?.data || []);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setSuggestions([]);
      } finally {
        setIsLoading(false);
      }
    };

    const debounceTimer = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounceTimer);
  }, [searchTerm]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/globalSearch?q=${encodeURIComponent(searchTerm)}`);
      onClose();
    }
  };

  const handleSuggestionClick = (car) => {
    navigate(`/product/${car.carModelId}`);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '8px',
          margin: 0,
          position: 'absolute',
          top: { xs: '60px', sm: '70px', md: '72px' },
          width: { xs: '90%', sm: '85%', md: '70%' },
          maxWidth: { xs: '95vw', sm: '500px', md: '700px' },
          maxHeight: { xs: 'calc(100vh - 100px)', sm: 'calc(100vh - 80px)', md: 'calc(100vh - 40px)' },
          // left: { xs: '5%', sm: '7.5%', md: 'auto' },
          // right: { xs: 'auto', sm: 'auto', md: 0 },
        }
      }}
    >
      <DialogContent sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Box component="form" onSubmit={handleSearchSubmit}>
          <Paper
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              boxShadow: 'none',
              // p: { xs: '1px 2px', sm: '2px 4px' },
            }}
          >
            <InputBase
              autoFocus
              fullWidth
              sx={{
                ml: 1,
                flex: 1,
                fontSize: { xs: '12px', sm: '14px' },
                // padding: { xs: '4px 0', sm: '6px 0' },
              }}
              placeholder="Search for cars (e.g. Audi)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <IconButton
              type="submit"
              sx={{
                p: { xs: '6px 12px', sm: '8px 16px' },
                backgroundColor: 'red',
                borderRadius: '6px',
                ml: 1,
                flexShrink: 0,
                '&:hover': {
                  backgroundColor: '#c62828',
                },
              }}
              aria-label="search"
            >
              <SearchIcon sx={{ color: 'white', fontSize: { xs: 18, sm: 24 } }} />
            </IconButton>
          </Paper>

          {searchTerm && (
            <Box sx={{
              position: 'relative',
              width: '100%'
            }}>
              {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                  <CircularProgress size={24} />
                </Box>
              ) : suggestions.length > 0 ? (
                <Box
                  sx={{
                    position: 'relative',
                    zIndex: 1400,
                    backgroundColor: 'white',
                    boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
                    borderRadius: '0 0 8px 8px',
                    maxHeight: { xs: '200px', sm: '300px' },
                    overflowY: 'auto',
                  }}
                >
                  <List dense>
                    {suggestions.map((car) => (
                      <ListItem
                        button
                        key={car.carModelId}
                        onClick={() => handleSuggestionClick(car)}
                        sx={{
                          '&:hover': { backgroundColor: '#fafafa' },
                          borderBottom: '1px solid #f0f0f0',
                          px: { xs: 1, sm: 2 },
                          py: { xs: 0.75, sm: 1 },
                        }}
                      >
                        <Box sx={{ width: "100%" }}>
                          <Typography variant="subtitle2" fontWeight="bold" sx={{ fontSize: { xs: '0.85rem', sm: '0.95rem' } }}>
                            {car.carBrandName} {car.carModelName}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: { xs: "10px", sm: "12px" },
                              mt: 0.5,
                            }}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {car.carFuel || "N/A"} • {car.carManufactureDate?.split("-")[0] || "N/A"}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="error"
                              fontWeight="medium"
                            >
                              ${car.carPrice?.toLocaleString() || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              ) : (
                <Box
                  sx={{
                    position: 'relative',
                    zIndex: 1400,
                    backgroundColor: 'white',
                    boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
                    borderRadius: '0 0 8px 8px',
                    padding: { xs: 1.5, sm: 2 },
                    textAlign: 'center',
                  }}
                >
                  <Typography fontSize={{ xs: '12px', sm: '14px' }}>
                    No results found for "{searchTerm}"
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const Notes = ({initialFilterState }) => {
  const [language, setLanguage] = useState("");
  const [currency, setCurrency] = useState("");
  const [country, setCountry] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [itemImages, setItemImages] = useState({});
  const [value, setValue] = React.useState("1");
  const location = useLocation();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [isMovingToWishlist, setIsMovingToWishlist] = React.useState(false);
  const [userData, setUser] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { url: profileImageUrl } = useSelector((state) => state.profileImage);
  const [currentUser, setCurrentUser] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [userName, setUserName] = useState("");
  const cartState = useSelector(state => state.cart);
  const navigate = useNavigate();
  const wishlistState = useSelector(state => state.wishlist);
  const wishlistItems = wishlistState.items;
  const wishlistCount = wishlistState.totalItems;
  const userFromStore = useSelector((state) => state.user);
  const authCheckRef = useRef(false);
  const [setWishlistCount] = useState(0);
  const [setWishlistItems] = useState([]);
  const [filterState, setFilterState] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const stateSearchResults = location.state?.searchResults;
  const stateSearchParams = location.state?.searchParams;
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [userState, setUserState] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    dispatch(fetchWishlist());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      localStorage.removeItem('filterState');
    };
  }, []);

  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const handleMobileMenuNavigate = (path) => {
    navigate(path);
    handleMobileMenuClose();
  };

  const handleAddToWishlist = async (modelId) => {
    const result = await dispatch(addToWishlist(modelId));
    if (result.success) {
      enqueueSnackbar("Added to wishlist successfully", { variant: 'success' });
    } else if (result.alreadyInWishlist) {
      enqueueSnackbar("This item is already in your wishlist", { variant: 'info' });
    } else {
      enqueueSnackbar(result.message || "Failed to add to wishlist", { variant: 'error' });
    }
  };

  // useEffect(() => {
  //   const stateFromNavigation = location.state?.filterState;
  //   const stateFromStorage = JSON.parse(localStorage.getItem('filterState'));

  //   if (stateFromNavigation || stateFromStorage) {
  //     setFilterState(stateFromNavigation || stateFromStorage);
  //   }
  // }, [location.state]);
  useEffect(() => {
  const stateFromNavigation = location.state?.filterState;
  const stateFromStorage = JSON.parse(localStorage.getItem('filterState'));
  if (initialFilterState) {
    setFilterState(initialFilterState);
  } else if (stateFromNavigation || stateFromStorage) {
    setFilterState(stateFromNavigation || stateFromStorage);
  }
}, [location.state, initialFilterState]);

  const renderFilterChips = () => {
    if (!filterState) return null;

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
        {filterState.selectedCategory && (
          <Chip
            label={`Body: ${filterState.selectedCategory.label}`}
            onDelete={() => { }}
          />
        )}
        {filterState.selectedBrand && (
          <Chip
            label={`Brand: ${filterState.selectedBrand.label}`}
            onDelete={() => { }}
          />
        )}
        {filterState.selectedModels.length > 0 && (
          <Chip
            label={`Models: ${filterState.selectedModels.map(m => m.carModelName).join(', ')}`}
            onDelete={() => { }}
          />
        )}
        {filterState.selectedYears.length > 0 && (
          <Chip
            label={`Years: ${filterState.selectedYears.map(y => y.year).join(', ')}`}
            onDelete={() => { }}
          />
        )}
      </Box>
    );
  };

  const handleRemoveFromWishlist = async (modelId) => {
    const result = await dispatch(removeFromWishlist(modelId));
    if (result.success) {
      enqueueSnackbar("Removed from wishlist successfully", { variant: 'success' });
    } else {
      enqueueSnackbar(result.message || "Failed to remove from wishlist", { variant: 'error' });
    }
  };

  useEffect(() => {
    setCartItems(cartState.items);
    setCartCount(cartState.totalItems);
  }, [cartState]);

  const tabHandleChangess = (event, newValue) => {
    setValue(newValue);
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleCloseIfComplete = () => {
    if (language && currency && country) {
      setDrawerOpen(false);
    }
  };

  const handleChangeLanguage = (event) => {
    setLanguage(event.target.value);
    handleCloseIfComplete();
  };

  const handleChangeCurrency = (event) => {
    setCurrency(event.target.value);
    handleCloseIfComplete();
  };

  const handleChangeCountry = (event) => {
    setCountry(event.target.value);
    handleCloseIfComplete();
  };

  useEffect(() => {
    if (!authCheckRef.current) {
      checkAuthToken();
      authCheckRef.current = true;
    }

    if (currentUser) {
      dispatch(fetchProfileImage());
    }
  }, [dispatch, currentUser]);

  const checkAuthToken = async () => {
    const token = localStorage.getItem("authToken");

    if (token) {
      try {
        const response = await fetch(
          "https://car.amar.co.jp/api/authorization/user/get/user/details",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setCurrentUser(data.userDetails);
        } else {
          localStorage.removeItem("authToken");
          setCurrentUser(null);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    }
  };

  const getInitials = (fullName) => {
    if (!fullName) return "";
    const parts = fullName.trim().split(" ").filter((part) => part.length > 0);
    if (parts.length === 0) return "";
    return parts.length > 1
      ? parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
      : parts[0][0].toUpperCase();
  };

  const handleChangess = (event, newValue) => {
    setValue(newValue);
  };

  const fetchItemImage = async (modelId) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No authentication token found");
        return null;
      }

      const response = await fetch(
        `https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${modelId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        return URL.createObjectURL(blob);
      } else {
        console.error(`Failed to fetch image for model ${modelId}`);
        return null;
      }
    } catch (error) {
      console.error(`Error fetching image for model ${modelId}:`, error);
      return null;
    }
  };

  const fetchCartData = async () => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        console.error("No authentication token found. Please log in.");
        return;
      }

      const response = await fetch(
        "https://car.amar.co.jp/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.code === 200) {
        setCartItems(data.items);
        setCartCount(data.totalItems);

        const imagePromises = data.items.map(async (item) => {
          const imageUrl = await fetchItemImage(item.modelId);
          return { modelId: item.modelId, imageUrl };
        });

        const imagesResults = await Promise.all(imagePromises);

        const imagesObject = imagesResults.reduce((acc, curr) => {
          if (curr.imageUrl) {
            acc[curr.modelId] = curr.imageUrl;
          }
          return acc;
        }, {});

        setItemImages(imagesObject);

      } else {
        console.error("Failed to fetch cart data:", data.message);
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  useEffect(() => {
    fetchCartData();
  }, []);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("authToken");

        if (!token) {
          console.error("No authentication token found. Please log in.");
          return;
        }

        const response = await fetch(
          "https://car.amar.co.jp/api/authorization/user/get/user/details",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setUserState(data.userDetails);
        } else {
          console.error("Failed to fetch user details");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    dispatch(clearCart());
    dispatch(clearWishlist());
    setCartItems([]);
    setCartCount(0);
    setItemImages({});
    setUserState(null);
    setCurrentUser(null);
    navigate("/login");
  };

  const handleMouseEnter = (event) => {
    clearTimeout(timeoutRef.current);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuMouseEnter = () => {
    clearTimeout(timeoutRef.current);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setAnchorEl(null);
    }, 100);
  };

  const handleLoginClick = () => {
    if (!userState) {
      navigate("/login");
    }
  };

  const handleProfileNavigation = () => {
    setAnchorEl(null);
    if (!currentUser) {
      navigate("/MyAccount");
    }
  };

  const shippingFee = 32.21;
  const total = cartItems.reduce((sum, item) => sum + item.price, 0);
  const removeItem = (itemId) => {
    setCartItems((prevItems) => {
      const updatedCart = prevItems.filter((item) => item.modelId !== itemId);
      return updatedCart.length > 0 ? updatedCart : [];
    });
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedItem) {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("No authentication token found. Please log in.");
          return;
        }

        const response = await fetch(
          `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${selectedItem.modelId}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          setCartItems((prevItems) => {
            const updatedCart = prevItems.filter((item) => item.modelId !== selectedItem.modelId);
            return updatedCart;
          });

          setCartCount((prevCount) => Math.max(0, prevCount - 1));

          setItemImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[selectedItem.modelId];
            return updatedImages;
          });
        } else {
          console.error("Failed to delete item from the server.");
        }
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
    setSelectedItem(null);
    setOpenDialog(false);
  };

  const handleMoveToWishlist = async () => {
    if (selectedItem) {
      setIsMovingToWishlist(true);
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("No authentication token found. Please log in.");
          setIsMovingToWishlist(false);
          return;
        }

        const response = await fetch(
          `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${selectedItem.modelId}&SelectType=MOVE_TO_WISHLIST`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        if (response.ok && data.code === 200) {
          setCartItems((prevItems) => {
            const updatedCart = prevItems.filter((item) => item.modelId !== selectedItem.modelId);
            return updatedCart;
          });

          setCartCount((prevCount) => Math.max(0, prevCount - 1));

          setItemImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[selectedItem.modelId];
            return updatedImages;
          });

          dispatch(fetchCart());
          dispatch(fetchWishlist());

          enqueueSnackbar("Item moved to wishlist successfully", { variant: 'success' });
        } else {
          console.error("Failed to move item to wishlist:", data.message);
          enqueueSnackbar("Failed to move item to wishlist", { variant: 'error' });
        }
      } catch (error) {
        console.error("Error moving item to wishlist:", error);
        enqueueSnackbar("Error moving item to wishlist", { variant: 'error' });
      } finally {
        setIsMovingToWishlist(false);
        setOpenDialog(false);
        setSelectedItem(null);
      }
    }
  };

  const iconWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer",
    minWidth: 60,
  };

  return (
    <div className="main-container">
      <Box
        sx={{
          // position: { xs: "relative", md: "fixed" },
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          backgroundColor: "white",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          transition: "top 0.3s ease",
          width: "100%",
          transform: "translateY(0)",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            px: { xs: 1.5, sm: 2.5, md: 3 },
            py: 1.3,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between" spacing={{ xs: 1, sm: 2 }}>
            {/* Logo */}
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={2}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { xs: 0.5, sm: 1 },
              }}
            >
              {/* Filter Icon - Only visible on screens below 900px */}
              {isTablet && (
                <Box
                  onClick={() => setFilterDrawerOpen(!filterDrawerOpen)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    p: { xs: 0.3, sm: 0.75 },
                    borderRadius: 1,
                    transition: "all 0.2s ease",
                    backgroundColor: filterDrawerOpen ? "rgba(220, 53, 69, 0.1)" : "transparent",
                    minWidth: { xs: 36, sm: 44 },
                    minHeight: { xs: 36, sm: 44 },
                    "&:hover": {
                      backgroundColor: "rgba(220, 53, 69, 0.1)",
                      "& svg": { color: "#dc3545" },
                    },
                  }}
                >
                  <TuneIcon sx={{ fontSize: { xs: 22, sm: 24 }, color: filterDrawerOpen ? "#dc3545" : "inherit" }} />
                </Box>
              )}
              <Box
                component="img"
                src={logo}
                alt="Logo"
                onClick={() => navigate("/")}
                sx={{
                  maxWidth: { xs: "120px", sm: "150px" },
                  width: "100%",
                  cursor: "pointer",
                  transition: "opacity 0.3s ease",
                  "&:hover": { opacity: 0.8 },
                }}
              />
            </Grid>

            {/* Desktop Navigation */}
            <Grid
              item
              md={6}
              lg={7}
              sx={{
                display: { xs: "none", md: "flex" },
                gap: { md: 1, lg: 2 },
              }}
            >
              {[
                { label: "About Us", path: "/aboutUs" },
                { label: "Contact", path: "/contactUs" },
                { label: "Purchase Flow", path: "/purchaseFlow" },
              ].map((item) => (
                <Button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  sx={{
                    color: "#333",
                    fontSize: { md: "0.9rem", lg: "1rem" },
                    fontWeight: 500,
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      width: 0,
                      height: "2px",
                      bottom: 0,
                      left: 0,
                      backgroundColor: "#dc3545",
                      transition: "width 0.3s ease",
                    },
                    "&:hover::after": {
                      width: "100%",
                    },
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Grid>

            {/* Icons Section */}
            <Grid
              item
              xs={6}
              sm={8}
              md={3}
              lg={3}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "flex-end", sm: "space-around" },
                gap: { xs: 0.2, sm: 1.5, md: 2 },
              }}
            >

              {/* Search Icon */}
              <Box
                onClick={() => setSearchModalOpen(true)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  p: { xs: 0.3, sm: 0.75 },
                  borderRadius: 1,
                  transition: "all 0.2s ease",
                  minWidth: { xs: 36, sm: 44 },
                  minHeight: { xs: 36, sm: 44 },
                  "&:hover": {
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                    "& svg": { color: "#dc3545" },
                  },
                }}
              >
                <SearchIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
                <Typography
                  sx={{
                    fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
                    mt: 0.3,
                    display: { xs: "none", lg: "block" },
                    fontWeight: 500,
                  }}
                >
                  Search
                </Typography>
              </Box>

              {/* Wishlist Icon */}
              <Box
                onClick={() => navigate("/myAccount/wishlist")}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  p: { xs: 0.3, sm: 0.75 },
                  borderRadius: 1,
                  transition: "all 0.2s ease",
                  minWidth: { xs: 36, sm: 44 },
                  minHeight: { xs: 36, sm: 44 },
                  "&:hover": {
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                    "& svg": { color: "#dc3545" },
                  },
                }}
              >
                <Badge badgeContent={wishlistCount} color="error" overlap="circular" sx={{ '& .MuiBadge-badge': { minWidth: 16, height: 16, fontSize: '10px', padding: '0 4px' } }}>
                  <FavoriteIcon sx={{ fontSize: { xs: 18, sm: 24 }, color: "#dc3545" }} />
                </Badge>
                <Typography
                  sx={{
                    fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
                    mt: 0.3,
                    display: { xs: "none", lg: "block" },
                    fontWeight: 500,
                  }}
                >
                  Wishlist
                </Typography>
              </Box>

              {/* inquiry History */}
              <Box
                onClick={() => {
                  setAnchorEl(null);
                  navigate("/myAccount/inquiryHistory");
                }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  p: { xs: 0.3, sm: 0.75 },
                  borderRadius: 1,
                  transition: "all 0.2s ease",
                  minWidth: { xs: 36, sm: 44 },
                  minHeight: { xs: 36, sm: 44 },
                  "&:hover": {
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                    "& svg": { color: "#dc3545" },
                  },
                }}
              >
                <ReceiptLongIcon
                  sx={{
                    // width: { xs: 30, sm: 20, md: 22, lg: 25 },
                    // height: { xs: 30, sm: 20, md: 22, lg: 25 },
                    width: { xs: 25, sm: 28, md: 28, lg: 25 },
                  height: { xs: 25, sm: 28, md: 28, lg: 25 },
                    transition: "all 0.2s ease",
                    color: "#dc3545",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
                    mt: 0.3,
                    display: { xs: "none", lg: "block" },
                    fontWeight: 500,
                  }}
                >
                  InquiryHistory
                </Typography>
              </Box>
{/* <Box
  onClick={() => {
    setAnchorEl(null);
    navigate("/myAccount/inquiryHistory");
  }}
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    p: { xs: 0.3, sm: 0.75 },
    borderRadius: 1,
    transition: "all 0.2s ease",
    minWidth: { xs: 36, sm: 44 },
    minHeight: { xs: 36, sm: 44 },
    "&:hover": {
      backgroundColor: "rgba(220, 53, 69, 0.1)",
      "& svg": { color: "#dc3545" },
      "& img": { opacity: 0.8 },
    },
  }}
>
  <Box
    component="img"
    src="/image/Invoice.svg"
    alt="inquiry"
    sx={{ 
      width: { xs: 30, sm: 20, md: 22, lg: 25 }, 
      height: { xs: 30, sm: 20, md: 22, lg: 25 },
      transition: "all 0.2s ease",
    }}
  />
  <Typography
    sx={{
      fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
      mt: 0.3,
      display: { xs: "none", lg: "block" },
      fontWeight: 500,
    }}
  >
    InquiryHistory
  </Typography>
</Box> */}
              

              {/* Cart Icon */}
              {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  p: { xs: 0.3, sm: 0.75 },
                  borderRadius: 1,
                  transition: "all 0.2s ease",
                  minWidth: { xs: 36, sm: 44 },
                  minHeight: { xs: 36, sm: 44 },
                  "&:hover": {
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                    "& svg": { color: "#dc3545" },
                  },
                }}
                onClick={() => {
                  if (!isOpen) {
                    setIsOpen(true);
                    fetchCartData();
                  }
                }}
              >
                <Badge badgeContent={cartCount} color="error" overlap="circular" sx={{ '& .MuiBadge-badge': { minWidth: 16, height: 16, fontSize: '10px', padding: '0 4px' } }}>
                  <LocalMallOutlinedIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
                </Badge>
                <Typography
                  sx={{
                    fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
                    mt: 0.3,
                    display: { xs: "none", lg: "block" },
                    fontWeight: 500,
                  }}
                >
                  Cart
                </Typography>

                {/* Cart Drawer */}
                <Drawer
                  anchor="right"
                  open={isOpen}
                  onClose={() => setIsOpen(false)}
                  slotProps={{
                    paper: {
                      sx: {
                        width: { xs: "100%", sm: 400, md: 450 },
                        display: "flex",
                        flexDirection: "column",
                      },
                    },
                  }}
                  ModalProps={{
                    keepMounted: false,
                    onBackdropClick: () => setIsOpen(false),
                  }}
                >
                  {/* Cart Header */}
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#333" }}>
                      My Shopping Cart ({cartCount})
                    </Typography>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(false);
                      }}
                      size="small"
                      sx={{ "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" } }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  {/* Cart Items */}
                  <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                    {cartItems.length > 0 ? (
                      <List sx={{ p: 0 }}>
                        {cartItems.map((item) => (
                          <ListItem
                            key={item.id}
                            sx={{
                              display: "flex",
                              gap: 1.5,
                              mb: 2,
                              p: 1,
                              borderRadius: 1,
                              backgroundColor: "#f9f9f9",
                              transition: "background-color 0.2s",
                              "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                          >
                            <Link
                              to={`/product/${item.modelId}`}
                              style={{
                                display: "flex",
                                textDecoration: "none",
                                color: "inherit",
                                flex: 1,
                                gap: 12,
                              }}
                            >
                              <Box
                                component="img"
                                src={itemImages[item.modelId] || "/placeholder.jpg"}
                                alt={item.modelName}
                                sx={{
                                  width: 80,
                                  height: 60,
                                  borderRadius: 1,
                                  objectFit: "cover",
                                  backgroundColor: "#f0f0f0",
                                  flexShrink: 0,
                                }}
                              />
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "#333",
                                    mb: 0.5,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.brand} {item.modelName}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#dc3545",
                                    fontWeight: 600,
                                  }}
                                >
                                  ${item.price}
                                </Typography>
                              </Box>
                            </Link>
                            <IconButton
                              onClick={() => handleDeleteClick(item)}
                              size="small"
                              sx={{
                                color: "#dc3545",
                                "&:hover": { backgroundColor: "rgba(220, 53, 69, 0.1)" },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </ListItem>
                        ))}
                      </List>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          py: 4,
                        }}
                      >
                        <ShoppingBagOutlinedIcon
                          sx={{ fontSize: 56, color: "#ddd", mb: 2 }}
                        />
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 600, color: "#666", mb: 0.5 }}
                        >
                          Your Cart is Empty
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#999" }}>
                          No items in your shopping cart yet
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Cart Footer */}
                  {cartItems.length > 0 && (
                    <Box
                      sx={{
                        p: 2,
                        borderTop: "1px solid #e0e0e0",
                        backgroundColor: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                      }}
                    >
                      <Box display="flex" gap={1}>
                        <TextField
                          placeholder="Coupon Code"
                          variant="outlined"
                          size="small"
                          fullWidth
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              fontSize: "0.9rem",
                              "&:hover fieldset": { borderColor: "#dc3545" },
                              "&.Mui-focused fieldset": { borderColor: "#dc3545" },
                            },
                          }}
                        />
                        <Button
                          variant="outlined"
                          sx={{
                            borderColor: "#dc3545",
                            color: "#dc3545",
                            fontWeight: 600,
                            minWidth: 90,
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "rgba(220, 53, 69, 0.1)",
                              borderColor: "#dc3545",
                            },
                          }}
                        >
                          Apply
                        </Button>
                      </Box>

                      <Box>
                        <Box display="flex" justifyContent="space-between" sx={{ mb: 1.5 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            Total
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 700, color: "#dc3545" }}
                          >
                            ${total.toFixed(2)}
                          </Typography>
                        </Box>
                      </Box>

                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                          navigate("/delivery");
                          setIsOpen(false);
                        }}
                        sx={{
                          backgroundColor: "#dc3545",
                          color: "white",
                          fontWeight: 600,
                          textTransform: "none",
                          py: 1.2,
                          "&:hover": { backgroundColor: "#c82333" },
                        }}
                      >
                        Proceed to Checkout
                      </Button>
                      <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => setIsOpen(false)}
                        sx={{
                          borderColor: "#e0e0e0",
                          color: "#333",
                          fontWeight: 600,
                          textTransform: "none",
                          py: 1.2,
                          "&:hover": { backgroundColor: "#f9f9f9" },
                        }}
                      >
                        Continue Shopping
                      </Button>
                    </Box>
                  )}
                </Drawer>

                {/* Delete Dialog */}
                <Dialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  slotProps={{
                    paper: { sx: { minWidth: 300 } },
                  }}
                >
                  <DialogTitle sx={{ fontWeight: 700 }}>Item Options</DialogTitle>
                  <DialogContent>
                    <DialogContentText sx={{ my: 2 }}>
                      What would you like to do?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions sx={{ p: 2 }}>
                    <Button
                      onClick={handleMoveToWishlist}
                      disabled={isMovingToWishlist}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        color: "#dc3545",
                      }}
                    >
                      {isMovingToWishlist ? (
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                      ) : (
                        "Move to Wishlist"
                      )}
                    </Button>
                    <Button
                      onClick={handleConfirmDelete}
                      variant="contained"
                      sx={{
                        backgroundColor: "#dc3545",
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": { backgroundColor: "#c82333" },
                      }}
                    >
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>
              {/* </Box> */} 

              {/* Profile/Login Icon */}
              <Box
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => {
                  if (!currentUser) {
                    navigate("/login");
                  }
                }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  p: { xs: 1, sm: 0.75 },
                  borderRadius: 1,
                  transition: "all 0.2s ease",
                  minWidth: { xs: 36, sm: 44 },
                  minHeight: { xs: 36, sm: 44 },
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.05)",
                  },
                }}
              >
                {currentUser ? (
                  <>
                    <Avatar
                      src={profileImageUrl}
                      alt={currentUser.firstName}
                      sx={{
                        width: { xs: 24, sm: 28 },
                        height: { xs: 24, sm: 28 },
                        fontSize: "0.75rem",
                        backgroundColor: "#dc3545",
                        flexShrink: 0,
                      }}
                      onError={(e) => {
                        console.error("Header image failed to load");
                        e.target.src = "";
                      }}
                    >
                      {getInitials(`${currentUser.firstName} ${currentUser.lastName || ""}`)}
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
                        // mt: 0.3,
                        display: { xs: "none", lg: "block" },
                        fontWeight: 500,
                        maxWidth: "80px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {currentUser.firstName}
                    </Typography>
                  </>
                ) : (
                  <>
                    <PermIdentityIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
                    <Typography
                      sx={{
                        fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem", lg: "0.8rem" },
                        mt: 0.3,
                        display: { xs: "none", lg: "block" },
                        fontWeight: 500,
                      }}
                    >
                      Login
                    </Typography>
                  </>
                )}

                {/* Profile Menu */}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                  MenuListProps={{
                    onMouseEnter: handleMenuMouseEnter,
                    onMouseLeave: handleMouseLeave,
                  }}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  disableScrollLock={true}
                  slotProps={{
                    paper: {
                      sx: {
                        mt: 1,
                        minWidth: currentUser ? 280 : 240,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                      },
                    },
                  }}
                >
                  {!currentUser ? (
                    <Box sx={{ p: 2 }}>
                      <Typography variant="body2" sx={{ mb: 1.5 }}>
                        <strong>New Customer?</strong>{" "}
                        <span
                          style={{
                            color: "#dc3545",
                            cursor: "pointer",
                            fontWeight: 600,
                            textDecoration: "underline",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setAnchorEl(null);
                            navigate("/signup");
                          }}
                        >
                          Sign Up
                        </span>
                      </Typography>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/about-us");
                        }}
                        sx={{ fontSize: "0.95rem" }}
                      >
                        About Us
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/contact-us");
                        }}
                        sx={{ fontSize: "0.95rem" }}
                      >
                        Contact Us
                      </MenuItem>
                    </Box>
                  ) : (
                    <Box sx={{ p: 0 }}>
                      {/* Profile Header */}
                      <Box
                        sx={{
                          p: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          backgroundColor: "#f9f9f9",
                          borderBottom: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          "&:hover": { backgroundColor: "#f0f0f0" },
                        }}
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount");
                        }}
                      >
                        <Avatar
                          src={profileImageUrl}
                          alt={currentUser.firstName}
                          sx={{
                            width: 44,
                            height: 44,
                            backgroundColor: "#dc3545",
                            fontSize: "1.1rem",
                            flexShrink: 0,
                          }}
                        >
                          {getInitials(
                            `${currentUser.firstName} ${currentUser.lastName || ""}`
                          )}
                        </Avatar>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 700,
                              color: "#333",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {currentUser.firstName} {currentUser.lastName || ""}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#999",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "block",
                            }}
                          >
                            {currentUser.email}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Menu Items */}
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <AccountBalanceIcon sx={{ color: "#dc3545", fontSize: 20 }} />
                        <span>My Account</span>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount/myProfile");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <PermIdentityIcon sx={{ color: "#dc3545", fontSize: 20 }} />
                        <span>My Profile</span>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount/orderHistory");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <LocalMallOutlinedIcon sx={{ color: "#dc3545", fontSize: 20 }} />
                        <span>Order History</span>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount/inquiryHistory");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Box
                          component="img"
                          src="/image/Invoice.svg"
                          alt="inquiry"
                          sx={{ width: 20, height: 20 }}
                        />
                        <span>Inquiry History</span>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount/wishlist");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Box
                          component="img"
                          src="/image/heart.svg"
                          alt="wishlist"
                          sx={{ width: 20, height: 20 }}
                        />
                        <span>My Wishlist</span>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/myAccount/myAddress");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Box
                          component="img"
                          src="/image/address.svg"
                          alt="Address Icon"
                          sx={{ width: 20, height: 20 }}
                        />
                        <span>My Address</span>
                      </MenuItem>

                      <Divider sx={{ my: 1 }} />
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          handleLogout();
                          navigate("/login");
                        }}
                        sx={{
                          fontSize: "0.95rem",
                          py: 1.2,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          color: "#dc3545",
                        }}
                      >
                        <LogoutOutlinedIcon sx={{ color: "#dc3545", fontSize: 20 }} />
                        <span>Logout</span>
                      </MenuItem>
                    </Box>
                  )}
                </Menu>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Filter Section - Shows Below Header on Tablet */}
        {isTablet && filterDrawerOpen && (
          <Box
            sx={{
              px: { xs: 1.5, sm: 2.5, md: 3 },
              py: 2,
              borderBottom: "1px solid #e0e0e0",
              backgroundColor: "#fff",
              width: "100%",
            }}
          >
            <BasicSelectFilter initialFilterState={filterState} />
          </Box>
        )}

        {/* BasicSelectFilter - Only visible on screens 900px and above */}
        {!isTablet && (
          <Box sx={{ display: 'block' }}>
            <BasicSelectFilter initialFilterState={filterState} />
          </Box>
        )}
      </Box>

      {/* <Toolbar sx={{ display: { xs: 'none', md: 'block' } }} /> */}
      <Toolbar sx={{ display: 'block' }} />  
      <SearchModal
        open={searchModalOpen}
        onClose={() => setSearchModalOpen(false)}
      />
    </div>
  );
};

export default Notes;